import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import isEmpty from 'src/app/lib/isEmpty';
import { BotService } from 'src/app/services/bot.service';
import { SocketService } from 'src/app/services/socket.service';
import { SpotService } from 'src/app/services/spot.service';
import { PairFacade } from 'src/app/store/botpair';
import { MarketPriceFacade } from 'src/app/store/marketprice';

interface CryptoData {
  symbol: string;
  price: number;
  change: number;
}

@Component({
  selector: 'app-ticker-tape',
  templateUrl: './ticker-tape.component.html',
  styleUrls: ['./ticker-tape.component.css']
})
export class TickerTapeComponent implements OnInit {
 public isMobileLayout = false;
  public isDestopLayout = false;
  chartData: any = {}
  pairData: any = {}
  chartStatus=false;
  cryptoPairs: any[] = [];
  selectedPair:any;
  tikerRoot: any;
 
  constructor(
    private spotService: SpotService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private socketService: SocketService,
    private service:BotService,
    private router: Router,
    private marketPriceFacade: MarketPriceFacade,
    private pairFacade: PairFacade,
    
  ) {
    
  }
  ngOnInit() {
    this.getPairs();
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1199;
    window.onload = () => this.isMobileLayout = window.innerWidth <= 1199;
   this.route.paramMap.subscribe(params => {
      this.tikerRoot = params.get('tikerRoot');
      if (!isEmpty(this.tikerRoot)) {
        this.socketService.emit("subscribe", this.tikerRoot.replace("_", ""));
      }
    });
  }

  ngOnDestroy() {
    if (!isEmpty(this.tikerRoot)) {
      this.socketService.emit("unSubscribe", this.tikerRoot.replace("_", ""));
    }
  }

 

 getPairs() {
    this.service.getPairList()
      .subscribe({
        next: (v: any) => {
          if (v.success) {
      this.cryptoPairs = v.result;

            if (isEmpty(this.tikerRoot)) {
              this.cryptoPairs = v.result;
              let pair = `${v.result[0].firstCurrencySymbol}_${v.result[0].secondCurrencySymbol}`
              this.router.navigateByUrl("/arbitrage_bot/" + pair)
            } else {
              this.pairFacade.setPair(v.result)
              const selectedPair = v.result.find((el: any) => el.tikerRoot === this.tikerRoot.replace('_', ''))
              if(isEmpty(selectedPair)){
                window.location.href = '/arbitrage_bot/'
              }
              this.pairData = selectedPair;
              this.marketPriceFacade.setSpotMarketPrice(selectedPair)
              this.service.setTradePair(selectedPair)
            }
          }
        },
        error: (err: any) => {
        }
      })
  }



}

